"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VideoControls = void 0;
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const underscore_1 = __importDefault(require("underscore"));
require("../controls.scss");
const Slider_1 = __importDefault(require("../../../../uikit/Slider"));
const SliderWrapper = styled_components_1.default.div `
    width: 100%;
    max-width: 300px;
    margin: auto 0;
`;
class VideoControls extends react_1.Component {
    constructor(props) {
        super(props);
        this.duration = (0, react_1.createRef)();
        this.currentTime = (0, react_1.createRef)();
        this.progressBar = (0, react_1.createRef)();
        this.progressBarSlider = (0, react_1.createRef)();
        this.onInput = (e) => {
            this.props.media.volume = e.target.value;
            this.setState({
                isMuted: false,
                volume: parseFloat(e.target.value),
            });
        };
        this.toggleMute = () => {
            const volume = this.state.isMuted ? this.state.volume : 0;
            this.props.media.volume = volume;
            this.setState({
                isMuted: !this.state.isMuted,
            });
        };
        this.componentDidMount = () => {
            // I've added custom video controls because of the need to target different elements (such as the canvas) rather than the an HTMLVideoElement which would have native controls in the shadowDOM
            // Initialte variables
            const video = this.props.media;
            if (!video)
                return;
            video.volume = 1;
            // Change video location when user clicks on progress bar
            this.progressBar.current.onclick = (event) => {
                let positionRatio = event.offsetX / this.progressBar.current.offsetWidth;
                video.currentTime = video.duration * positionRatio;
            };
            // update display as video seeks
            video.ontimeupdate = underscore_1.default.throttle(() => {
                // Update progress bar
                let durationRatioWidth = (video.currentTime / video.duration) * 100 + "%";
                this.progressBarSlider.current.style.width = durationRatioWidth;
                // Update playback duration
                let currentTime = new Date(0, 0, 0, 0, 0, 0, video.currentTime * 1000);
                currentTime = this.toTimeString(currentTime);
                this.currentTime.current.innerHTML = currentTime;
            }, 200);
        };
        // Function to convert a date object to 'mm:ss' format
        this.toTimeString = (date) => {
            let d = date.toTimeString().split(" ")[0];
            d = d.slice(3, 8);
            return d;
        };
        const duration = this.toTimeString(new Date(0, 0, 0, 0, 0, 0, this.props.media.duration * 1000));
        this.state = {
            duration,
            volume: 1,
            isMuted: false,
        };
    }
    render() {
        return (react_1.default.createElement("div", { className: "video-controls" },
            react_1.default.createElement("div", { ref: this.progressBar, className: "progress-bar-parent flex" },
                react_1.default.createElement("div", { className: "progress-bar-background" },
                    react_1.default.createElement("div", { ref: this.progressBarSlider, className: "progress-bar" }))),
            react_1.default.createElement("button", { onClick: this.props.togglePause, className: "material-icons " +
                    (this.props.isPaused ? "play" : "pause") }),
            react_1.default.createElement("div", { className: "playback-duration", ref: this.duration },
                react_1.default.createElement("span", { ref: this.currentTime, className: "progress" }, "00:00"),
                react_1.default.createElement("span", null, "/"),
                react_1.default.createElement("span", { className: "duration" }, this.state.duration)),
            react_1.default.createElement("button", { onClick: this.toggleMute, className: "material-icons " +
                    (!this.state.isMuted ? "unmute" : "mute") }),
            react_1.default.createElement(SliderWrapper, null,
                react_1.default.createElement(Slider_1.default, { min: 0, max: 1, onInput: this.onInput, onChange: this.onInput, value: this.state.isMuted ? 0 : this.state.volume, step: 0.01 }))));
    }
}
exports.VideoControls = VideoControls;
exports.default = VideoControls;
